/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-03 16:16:50
 * @LastEditors: K
 * @LastEditTime: 2022-09-08 16:23:49
 */
import { ADMIN_API_PREFIX } from './constant'
import { Request } from './request'

//  获取表格列表
export const getTableListFn = (): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/board/tenantSearchByCategory`,
    method: 'GET',
  }
}
//  获取表格列表
export const getDataListFn = (): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/board/sysBoardList`,
    method: 'GET',
  }
}

//  获取表格列表
export interface getAnalysisRecordListFnParams {
  current: number;
  size: number;
}
export const getAnalysisRecordListFn = (params: getAnalysisRecordListFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/board/sysBoardAnalysisLogPage`,
    method: 'GET',
    params
  }
}
// 获取折线图数据
export interface getTendencyChartFnParams {
  trendChartType: number;
  type?: number;
}
export const getTendencyChartFn = (params: getTendencyChartFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tendencyChart/board/getTendencyChart`,
    method: 'GET',
    params
  }
}
// 机构数据-各省机构总览
export interface getOverviewListFnParams {
  regionType: number
  type: number
}
export const getOverviewListFn = (params: getOverviewListFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenant/board/getRegionTenantBoard`,
    method: 'GET',
    params
  }
}
// 机构数据-获取数据看板数据 全部 、 好医点、 聚网
export interface getAllDataFnParams {
  type: number;
}
export const getAllDataFn = (params: getAllDataFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenant/board/getTenantBoard`,
    method: 'GET',
    params
  }
}
// 机构数据-获取机构获取明细
export interface getActiveInstitutionsFnParams {
  cityCode?: number;  
  countyCode?: number;  
  current: number;  
  insuranceStatus?: number;  
  name?: number;  
  provinceCode?: number;  
  size?: number;  
  sort?: number;  
  tenantCategory?: number;  
  tenantType?: number;  
}
export const getActiveInstitutionsFn = (params: getActiveInstitutionsFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenant/board/activeTenantList`,
    method: 'GET',
    params
  }
}

// 用户数据-获取数据看板数据 全部 、 好医点、 聚网
export interface getUserAllDataFnParams {
  type: number;
}
export const getUserAllDataFn = (params: getUserAllDataFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/doctor/board/getDoctorBoard`,
    method: 'GET',
    params
  }
}
// 用户数据-机构医生、医生性别、医生年龄饼状图
export interface getUserDoctorPieFnParams {
  type: number;
}
export const getUserDoctorPieFn = (params: getUserDoctorPieFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/doctor/board/getDoctorPieChartBoard`,
    method: 'GET',
    params
  }
}

// 门诊数据-数据看板
export interface getOutpatienDataFnParams {
  type: number;
  cityCode?: string
  countyCode?: string
  endTime?: string
  keyWord?: string
  provinceCode?: string
  startTime?: string
}
export const getOutpatienDataFn = (params: getOutpatienDataFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/outpatient/board/getOutpatientBoard`,
    method: 'GET',
    params
  }
}
// 门诊数据-饼状图
export const getOutpatienDataPieFn = (params: getOutpatienDataFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/outpatient/board/getOutpatientPieChart`,
    method: 'GET',
    params
  }
}

// 门诊数据-饼状图
export const getAddServicesDataFn = (): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/product/board/getProductBoard`,
    method: 'GET',
    params: {
      type: 0
    }
  }
}
// 使用详情-列表
export interface getUseDetailFnParams {
  cityCode?: string
  countyCode?: string
  provinceCode?: string
  current: number
  endTime?: string
  keyWord?: string
  insuranceStatus?: number
  name?: string
  platformType?:number
  potionStatus?:number
  size?:number
  startTime?: string  
  tenantCategory?: string  
  tenantType?: number  
}
export const getUseDetailFn = (params: getUseDetailFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenant/tenantDetailsList`,
    method: 'GET',
    params
  }
}
// 使用详情-列表-前五疾病
export interface getUseDetailFiveFnParams {
  tenantId?: string
}
export const getUseDetailFiveFn = (params: getUseDetailFiveFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenant/getDiseaseRanking`,
    method: 'GET',
    params
  }
}
// 使用详情-列表-导出

export const getUseDetailExportFn = (params: getUseDetailFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenant/tenantDetailsListExport`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}
// 使用详情-列表-前五疾病
export interface getRegulatoryDataFnParams {
  type?: number
}
export const getRegulatoryDataFn = (params: getRegulatoryDataFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/regulation/getRegulation`,
    method: 'GET',
    params
  }
}
// 全国医疗数据

export const getAllNationalFn = (): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/regulation/getMedicalData`,
    method: 'GET',
    
  }
}